import { makeStyles } from 'tss-react/mui';

const useStylesVisualEditorSectionBlock: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme,
): MaterialUIStyles => ({
  visualEditorSectionBlock: {
    padding: 20,
    minHeight: 40,
    borderBottom: `1px solid ${theme.palette.info.main}`,
  },
  visualEditorSectionBlockInline: {
    padding: '5px 10px',
    minHeight: 10,
    borderBottom: 'none',
  },
  visualEditorSectionBlockInternal: {
    paddingTop: '15px',
    paddingBottom: '15px',
  },
}));

export default useStylesVisualEditorSectionBlock;
